import { render } from "./account-validation.vue?vue&type=template&id=a44610e2"
import script from "./account-validation.vue?vue&type=script&lang=js"
export * from "./account-validation.vue?vue&type=script&lang=js"

import "./account-validation.vue?vue&type=style&index=0&id=a44610e2&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__